export default __webpack_public_path__ + "static/media/import-fuel_purchasesSample.f86efc43.xlsx";